import { TSetting } from '../types'
import {
    getOptionsForSetting,
    getSelectedOption,
    getSelectedSortDirection,
    getSortAndFilterSetting,
} from './settingsContract'
import { SortAndFilterSettingsConfig } from './types'

// groupId is the id of the repo or task section (used when sorting views in the overview page)
const getSortAndFilterSettings = <T>(
    settings: TSetting[],
    config: SortAndFilterSettingsConfig<T>,
    groupId?: string,
    suffix?: '_main' | '_overview' // main if a folder, overview if the overview page
) => {
    const sortingPreference = getSortAndFilterSetting(settings, config.settingsGroup, 'sort', groupId, suffix)
    const sortDirection = getSortAndFilterSetting(settings, config.settingsGroup, 'direction', groupId, suffix)
    const filterPreference = getSortAndFilterSetting(settings, config.settingsGroup, 'filter', groupId, suffix)

    const sortOptions = getOptionsForSetting(config.sortOptions, sortingPreference)
    const filterOptions = getOptionsForSetting(config.filterOptions, filterPreference)

    const selectedSort = getSelectedOption(sortOptions, sortingPreference, config.defaultSortsAndFilters.selectedSort)
    const selectedSortDirection = getSelectedSortDirection(
        sortDirection,
        config.defaultSortsAndFilters.selectedSortDirection
    )
    const selectedFilter = getSelectedOption(
        filterOptions,
        filterPreference,
        config.defaultSortsAndFilters.selectedFilter
    )

    return {
        selectedSort,
        selectedSortDirection,
        selectedFilter,
        isLoading: false,
    }
}

export default getSortAndFilterSettings
